module.exports = __webpack_public_path__ + "img/Dantam Hair 32.ae7c0273.jpg";